import { createContext } from 'react';
export var LabelPrefixContext = createContext('');
//# sourceMappingURL=LabelPrefixContext.js.map